export type TourStepPlacement = 'right' | 'left' | 'top' | 'bottom' | 'center';

export interface TourStep {
  /** Stable id, also used as the `data-tour` attribute on the target element. */
  id: string;
  title: string;
  body: string;
  /** When omitted the coachmark is rendered as a centered modal (used for the welcome step). */
  targetSelector?: string;
  placement?: TourStepPlacement;
  /** Selector used in place of `targetSelector` on mobile (< lg). Sidebar
      items live in a drawer that's closed by default on mobile, so we point
      the spotlight at the hamburger menu instead and let the bottom-sheet
      copy explain where the feature lives in the menu. */
  mobileTargetSelector?: string;
  /** Optional body override shown only on mobile so we can say "Open the
      menu and tap …" without changing desktop copy. */
  mobileBody?: string;
}

/**
 * MVP step list. Targets the most-used surfaces in the sidebar + the Create New CTA.
 * Add steps here as more feature affordances ship.
 */
const MENU_TARGET = '[data-tour="menu-toggle"]';

export const tourSteps: TourStep[] = [
  {
    id: 'welcome',
    title: 'Welcome to LiLi',
    body: 'Quick tour of the spots you’ll use most. Takes about 30 seconds. Skip any time.',
    placement: 'center',
  },
  {
    id: 'create-new',
    title: 'Create new content',
    body: 'Kick off a new post here. LiLi drafts in your voice across all your connected channels.',
    targetSelector: '[data-tour="create-new"]',
    placement: 'right',
    mobileTargetSelector: MENU_TARGET,
    mobileBody:
      'Open the menu to find Create New — LiLi drafts in your voice across all your connected channels.',
  },
  {
    id: 'nav-chat',
    title: 'Agent LiLi',
    body: 'Chat with LiLi to brainstorm, draft, and refine posts.',
    targetSelector: '[data-tour="nav-chat"]',
    placement: 'right',
    mobileTargetSelector: MENU_TARGET,
    mobileBody: 'Open the menu and tap Agent LiLi to brainstorm, draft, and refine posts.',
  },
  {
    id: 'nav-calendar',
    title: 'Calendar',
    body: 'See everything scheduled and drag posts to reschedule.',
    targetSelector: '[data-tour="nav-calendar"]',
    placement: 'right',
    mobileTargetSelector: MENU_TARGET,
    mobileBody: 'Open the menu and tap Calendar to see everything scheduled.',
  },
  {
    id: 'nav-knowledge-base',
    title: 'Knowledge Base',
    body: 'Upload notes, decks, and references that LiLi uses to ground your content.',
    targetSelector: '[data-tour="nav-knowledge-base"]',
    placement: 'right',
    mobileTargetSelector: MENU_TARGET,
    mobileBody:
      'Open the menu and tap Knowledge Base to upload notes and references that ground your content.',
  },
  {
    id: 'nav-preferences',
    title: 'Brand DNA',
    body: 'Tune tone, niche, and goals here to shape every generated post.',
    targetSelector: '[data-tour="nav-preferences"]',
    placement: 'right',
    mobileTargetSelector: MENU_TARGET,
    mobileBody: 'Open the menu and tap Brand DNA to tune tone, niche, and goals.',
  },
];
